import { Checkbox, TableSortLabel } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { Column } from "components/Table/Table";
import React from "react";

export interface SimpleHeaderProps<T extends any> {
  onRequestSort?: (event: React.MouseEvent<unknown>, property: any) => void;
  order?: "asc" | "desc";
  orderBy?: keyof T;
  rowCount?: number;
  columns?: Column<T>[];
  selectedRowsCount?: number;
  onAllRowChecked?(event: React.ChangeEvent<HTMLInputElement>): void;
  hasSelection?: boolean;
  hasChecked?: boolean;
  asAction?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      [theme.breakpoints.down("xs")]: { width: "auto" },
    },
    header: {
      width: "100%",
      marginBottom: "-30px",
      background: "#e2f4fb",
      [theme.breakpoints.down("xs")]: { width: "71rem", height: "3rem" },
    },
    th: {
      textAlign: "left",
      padding: 8,
      fontSize: 16,
      fontWeight: 600,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      color: "#757a93",
      borderBottom: "1px #ddd solid",
      "&:last-child": {
        position: "relative",
        right: "-350px",
        [theme.breakpoints.down("xs")]: {
          position: "relative",
          right: "-190px",
        },
      },
    },
  })
);
export function SimpleHeader<T extends any>({
  columns,
  hasSelection,
  hasChecked,
  asAction,
  onAllRowChecked,
  selectedRowsCount = 0,
  rowCount = 0,
  onRequestSort,
  orderBy,
  order,
}: SimpleHeaderProps<T>) {
  const styles = useStyles();
  const createSortHandler = (property: keyof T) => (event: React.MouseEvent<unknown>) => {
    onRequestSort(event, property);
  };
  return (
    <div className={styles.header}>
      <thead>
        <tr>
          {hasSelection && (
            <td>
              <Checkbox
                color="primary"
                onChange={onAllRowChecked}
                indeterminate={selectedRowsCount > 0 && selectedRowsCount < rowCount}
                checked={rowCount > 0 && selectedRowsCount === rowCount}
              />
            </td>
          )}
          {columns.map((item) => (
            <th key={item.field} align="left" className={styles.th}>
              <TableSortLabel
                active={orderBy === item.field}
                direction={orderBy === item.field ? order : "asc"}
                onClick={createSortHandler(item.field as any)}
              >
                {item.title}
                {orderBy === item.field ? (
                  <span>{order === "desc" ? "sorted descending" : "sorted ascending"}</span>
                ) : null}
              </TableSortLabel>
            </th>
          ))}
          {asAction && <th key="Actions" className={styles.th} />}
        </tr>
      </thead>
    </div>
  );
}
